import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Container, Image } from "react-bootstrap";
import "./index.css";
import "./userCompanyInfo.css";
import CustomButton from "../../../common/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import { getGeoData, getPinCodeAreas, getPinCodes } from "../../../../actions/structure.action";
import isEmpty from "../../../../utils/is-Empty";
import { capitalize } from "lodash";
import CustomSelectDropdown from "../../../common/CustomSelectDropdown";
import FilterObjectsByKeyValue from "../../../../utils/FilterObjectsByKeyValue";
import {
  deleteUserAddressInfo,
  getUserAddressInfo,
  patchUserAddressInfo,
  postUserAddressInfo,
} from "../../../../actions/user.actions";
import inputValidation from "../../../../utils/inputValidation";
import { useDialog } from "../../../../helpers/useDialog";
import PageSpinner from "../../../common/PageSpinner";
import { DeleteIcon, EditIcon } from "../../../../assets/svg/svg-icons";
import { toast } from "react-toastify";

const UserAddressInfo = ({ title = "Address Info", userId, userObj }) => {
  const dispatch = useDispatch();
  const { alert, confirm, DialogModal } = useDialog();
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [uploadFormObj, setUploadFormObj] = useState({});
  const [addresses, setAddresses] = useState({});
  const [currentUpdateId, setCurrentUpdateId] = useState("");
  const [pinCodesData, setPinCodesData] = useState([]);
  const [areaData, setAreaData] = useState([]);

  const { requestCall, bhareeAdminBasicTable, countries, countryStates, countryStateCities } =
    useSelector((state) => {
      return state;
    });

  useEffect(() => {
    // console.log("userObj: ", userObj);
    if (isEmpty(uploadFormObj?.full_name) && userObj?.business_info?.business_name) {
      onSelectValue("full_name", userObj?.business_name);
    }
    if (isEmpty(uploadFormObj?.primary_number) && userObj?.mobile_number) {
      onSelectValue("primary_number", userObj?.mobile_number);
    }
  }, [userObj]);

  useEffect(() => {
    callUserAddressInfoAPI(userId, dispatch);
  }, [dispatch, userId]);

  useEffect(() => {
    setIsCreateMode(false);
    setIsUpdateMode(false);
    if (isEmpty(addresses?.data) && addresses?.data?.length < 1) {
      setIsCreateMode(true);
    }
  }, [addresses]);

  const callUserAddressInfoAPI = (mUserId, dispatch) => {
    setLoading(true);
    getUserAddressInfo(mUserId, dispatch)
      .then((res) => {
        setAddresses(res);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSelectValue = (key, value) => {
    // console.log("*** change ", key, value);
    let updatedObj = {};
    updatedObj[key] = value;

    setUploadFormObj((previousValues) => ({
      ...previousValues,
      ...updatedObj,
    }));
  };

  const onSelectValueValidation = (key, value, maxLength = 1000, numericOnly = false) => {
    setErrorMsg({});
    let updatedObj = {};
    let validate = inputValidation(value, maxLength, numericOnly);
    if (validate.pass) {
      updatedObj[key] = validate.finalValue;
      setErrorMsg({ [key]: validate.msg });
      setUploadFormObj((previousValues) => ({
        ...previousValues,
        ...updatedObj,
      }));
    } else {
      setErrorMsg({ [key]: validate.msg });
    }
  };

  useEffect(() => {
    onSelectValue(
      "state",
      FilterObjectsByKeyValue(countryStates?.data, "name", "Maharashtra")[0].name
    );
    onSelectValue("country", FilterObjectsByKeyValue(countries?.data, "name", "India")[0].name);
  }, [dispatch, countryStates, countries]);

  useEffect(() => {
    if (
      !isEmpty(uploadFormObj?.state) &&
      !isEmpty(countries?.data) &&
      !isEmpty(countryStates?.data)
    ) {
      getGeoData(
        dispatch,
        FilterObjectsByKeyValue(countries.data, "name", uploadFormObj?.country)[0].isoCode,
        FilterObjectsByKeyValue(countryStates.data, "name", uploadFormObj?.state)[0].isoCode
      );
    }
  }, [uploadFormObj?.state, countries, countryStates, dispatch]);

  const onSetUpdateObj = async (address) => {
    await getGeoData(
      dispatch,
      FilterObjectsByKeyValue(countries.data, "name", address?.country)[0].isoCode,
      FilterObjectsByKeyValue(countryStates.data, "name", address?.state)[0].isoCode
    );
    setUploadFormObj(address);
    setIsCreateMode(true);
    setIsUpdateMode(true);
    setCurrentUpdateId(address?.id);
    displayPinCodes(address?.city);
    displayPinCodeAreas(address?.pin_code);
  };

  const displayPinCodes = async (city) => {
    setPinCodesData([]);
    const mPinCodesData = await getPinCodes(dispatch, city);
    if (mPinCodesData && mPinCodesData?.payload && mPinCodesData?.payload?.length > 0) {
      setPinCodesData(mPinCodesData?.payload);
    }
  };

  const displayPinCodeAreas = async (pincode) => {
    setAreaData([]);
    const mPinCodeAreas = await getPinCodeAreas(dispatch, pincode);
    if (mPinCodeAreas && mPinCodeAreas?.payload && mPinCodeAreas?.payload?.length > 0) {
      setAreaData(mPinCodeAreas?.payload);
    }
  };

  const createUpdateAddress = (e) => {
    e.preventDefault();
    console.log("UserAddress: uploadFormObj ", uploadFormObj);

    onSelectValue("user_id", userId);

    if (
      !isEmpty(uploadFormObj) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "full_name") &&
      !isEmpty(uploadFormObj.full_name) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "primary_number") &&
      !isEmpty(uploadFormObj.primary_number) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "city") &&
      !isEmpty(uploadFormObj.city) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "state") &&
      !isEmpty(uploadFormObj.state) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "pin_code") &&
      !isEmpty(uploadFormObj.pin_code) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "address_line_1") &&
      !isEmpty(uploadFormObj.address_line_1) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "address_type_id") &&
      !isEmpty(uploadFormObj.address_type_id) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "area") &&
      !isEmpty(uploadFormObj.area)
    ) {
      setLoading(true);
      if (isUpdateMode) {
        patchUserAddressInfo(userId, currentUpdateId, uploadFormObj, dispatch)
          .then((res) => {
            if (res.success) {
              toast.success(res.message);
              setIsUpdateMode(false);
              setIsCreateMode(false);
              callUserAddressInfoAPI(userId, dispatch);
            } else {
              toast.error(res.message);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        postUserAddressInfo(userId, uploadFormObj, dispatch)
          .then((res) => {
            if (res.success) {
              toast.success(res.message);
              setIsUpdateMode(false);
              setIsCreateMode(false);
              callUserAddressInfoAPI(userId, dispatch);
            } else {
              toast.error(res.message);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      }
    } else {
      toast.error("Please enter all the mandatory data.");
    }
  };

  const addressForm = (
    <>
      <Row className="m-0 form-row ">
        <Row className="m-0 px-0 w-full px-0 title-button-row mb-2">
          <Col xs={6} md={6} className="m-0 p-0">
            <h2>{!isUpdateMode ? "Create New Address" : "Update Address"}</h2>
          </Col>
          <Col xs={6} md={6} className="m-0 p-0 text-end">
            {addresses?.data?.length > 0 && (
              <Button
                className="btn-theme"
                size="sm"
                onClick={() => {
                  setIsCreateMode(false);
                  setUploadFormObj({});
                  setErrorMsg({});
                }}
              >
                <i className="bi bi-list"></i> List
              </Button>
            )}
          </Col>
        </Row>
        <Form className=" modal-custom-class" onSubmit={createUpdateAddress}>
          <Row className="m-0">
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Full name"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.full_name || userObj?.business_info?.business_name}
                  onChange={(e) => onSelectValueValidation("full_name", e.target.value, 50)}
                />
                {!isEmpty(errorMsg) &&
                  Object.prototype.hasOwnProperty.call(errorMsg, "full_name") && (
                    <p className="error-msg">{errorMsg.full_name}</p>
                  )}
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Primary number"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.primary_number || userObj?.mobile_number}
                  onChange={(e) =>
                    onSelectValueValidation("primary_number", e.target.value, 10, true)
                  }
                />
                {!isEmpty(errorMsg) &&
                  Object.prototype.hasOwnProperty.call(errorMsg, "primary_number") && (
                    <p className="error-msg">{errorMsg.primary_number}</p>
                  )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>{"Alternate number"}</Form.Label>
                <Form.Control
                  type="text"
                  value={uploadFormObj?.alternate_number || ""}
                  onChange={(e) =>
                    onSelectValueValidation("alternate_number", e.target.value, 10, true)
                  }
                />
                {!isEmpty(errorMsg) &&
                  Object.prototype.hasOwnProperty.call(errorMsg, "alternate_number") && (
                    <p className="error-msg">{errorMsg.alternate_number}</p>
                  )}
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              {!bhareeAdminBasicTable.loading &&
                !isEmpty(bhareeAdminBasicTable?.data?.addressTypes) &&
                bhareeAdminBasicTable?.data?.addressTypes?.length > 0 && (
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      {"Address Type"}
                      <span className="redStreSpan">{"*"}</span>
                    </Form.Label>

                    <CustomSelectDropdown
                      style={{
                        chips: {
                          margin: 0,
                        },
                        multiselectContainer: {
                          backgroundColor: "#f8f8f8",
                        },
                        option: {
                          background: "#fbb040",
                          color: "#FFFFFF",
                          borderBottom: "1px solid #FFFFFF",
                        },
                      }}
                      options={bhareeAdminBasicTable?.data?.addressTypes?.filter((el) => {
                        if (userObj?.role?.role_name === "BUYER") {
                          return el.type_name === "Delivery" || el.type_name === "Billing";
                        } else if (userObj?.role?.role_name === "SELLER") {
                          if (userObj?.roles_type?.role_type_name === "MANUFACTURER") {
                            return (
                              el.type_name === "Warehouse" ||
                              el.type_name === "Billing" ||
                              el.type_name === "Factory"
                            );
                          } else if (userObj?.roles_type?.role_type_name === "DISTRIBUTOR") {
                            return el.type_name === "Warehouse" || el.type_name === "Billing";
                          }
                        }
                        return true;
                      })}
                      onSelect={(e) => {
                        onSelectValue("address_type_id", e[0]);
                        if (e[0].type_name === "Factory") {
                          onSelectValue("set_default", true);
                        } else {
                          onSelectValue("set_default", false);
                        }
                      }}
                      selectedValues={
                        Object.prototype.hasOwnProperty.call(uploadFormObj, "address_type_id")
                          ? [uploadFormObj?.address_type_id]
                          : []
                      }
                      displayValue={"type_name"}
                      disable={isUpdateMode ? true : false}
                      singleSelect
                    />
                  </Form.Group>
                )}
            </Col>

            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Address Line 1"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.address_line_1 || ""}
                  onChange={(e) => onSelectValueValidation("address_line_1", e.target.value, 100)}
                />
                {!isEmpty(errorMsg) &&
                  Object.prototype.hasOwnProperty.call(errorMsg, "address_line_1") && (
                    <p className="error-msg">{errorMsg.address_line_1}</p>
                  )}
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>{"Address Line 2"}</Form.Label>
                <Form.Control
                  type="text"
                  value={uploadFormObj?.address_line_2 || ""}
                  onChange={(e) => onSelectValueValidation("address_line_2", e.target.value, 100)}
                />
                {!isEmpty(errorMsg) &&
                  Object.prototype.hasOwnProperty.call(errorMsg, "address_line_2") && (
                    <p className="error-msg">{errorMsg.address_line_2}</p>
                  )}
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>{"Address Line 3"}</Form.Label>
                <Form.Control
                  type="text"
                  value={uploadFormObj?.address_line_3 || ""}
                  onChange={(e) => onSelectValueValidation("address_line_3", e.target.value, 100)}
                />
                {!isEmpty(errorMsg) &&
                  Object.prototype.hasOwnProperty.call(errorMsg, "address_line_3") && (
                    <p className="error-msg">{errorMsg.address_line_3}</p>
                  )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Country"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                {!isEmpty(countries?.data) && countries.data?.length > 0 && (
                  <CustomSelectDropdown
                    style={{
                      chips: {
                        margin: 0,
                      },
                      multiselectContainer: {
                        backgroundColor: "#f8f8f8",
                      },
                      option: {
                        background: "#fbb040",
                        color: "#FFFFFF",
                        borderBottom: "1px solid #FFFFFF",
                      },
                    }}
                    options={countries?.data}
                    onSelect={(e) => onSelectValue("country", e[0].name)}
                    selectedValues={
                      Object.prototype.hasOwnProperty.call(uploadFormObj, "country")
                        ? FilterObjectsByKeyValue(countries.data, "name", uploadFormObj?.country)
                        : []
                    }
                    displayValue={"name"}
                    disable
                    singleSelect
                  />
                )}
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"State"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>

                <CustomSelectDropdown
                  style={{
                    chips: {
                      margin: 0,
                    },
                    multiselectContainer: {
                      backgroundColor: "#f8f8f8",
                    },
                    option: {
                      background: "#fbb040",
                      color: "#FFFFFF",
                      borderBottom: "1px solid #FFFFFF",
                    },
                  }}
                  options={
                    !isEmpty(countryStates?.data) && countryStates.data?.length > 0
                      ? countryStates?.data
                      : [{ name: "Please select country" }]
                  }
                  onSelect={(e) => onSelectValue("state", e[0].name)}
                  selectedValues={
                    Object.prototype.hasOwnProperty.call(uploadFormObj, "state")
                      ? FilterObjectsByKeyValue(countryStates?.data, "name", uploadFormObj?.state)
                      : []
                  }
                  displayValue={"name"}
                  disable
                  singleSelect
                  // selectionLimit={1}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"City"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <CustomSelectDropdown
                  style={{
                    multiselectContainer: {
                      backgroundColor: "#f8f8f8",
                    },
                    chips: {
                      background: "#fbb040",
                      margin: 0,
                    },
                    option: {
                      background: "#fbb040",
                      color: "#FFFFFF",
                      borderBottom: "1px solid #FFFFFF",
                    },
                  }}
                  options={
                    !isEmpty(countryStateCities?.data) && countryStateCities.data?.length > 0
                      ? countryStateCities?.data
                      : [{ name: "Please select state" }]
                  }
                  onSelect={(e) => {
                    onSelectValue("city", e[0].name);
                    displayPinCodes(e[0].name);
                  }}
                  selectedValues={
                    Object.prototype.hasOwnProperty.call(uploadFormObj, "city")
                      ? FilterObjectsByKeyValue(
                          countryStateCities?.data,
                          "name",
                          uploadFormObj?.city
                        )
                      : []
                  }
                  displayValue={"name"}
                  disable={isUpdateMode ? true : false}
                  // singleSelect
                  selectionLimit={1}
                />
              </Form.Group>
            </Col>

            {(() => {
              if (
                uploadFormObj?.city === "Pune" ||
                uploadFormObj?.city === "Pimpri" ||
                uploadFormObj?.city === "Pimpri-Chinchwad"
              ) {
                return (
                  <Col xs={12} md={12}>
                    <Row>
                      <Col xs={12} md={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            {"Pin code"}
                            <span className="redStreSpan">{"*"}</span>
                          </Form.Label>
                          <CustomSelectDropdown
                            style={{
                              multiselectContainer: {
                                backgroundColor: "#f8f8f8",
                              },
                              chips: {
                                background: "#fbb040",
                                margin: 0,
                              },
                              option: {
                                background: "#fbb040",
                                color: "#FFFFFF",
                                borderBottom: "1px solid #FFFFFF",
                              },
                            }}
                            options={pinCodesData}
                            onSelect={(e) => {
                              onSelectValue("pin_code", e[0].pincode);
                              displayPinCodeAreas(e[0].pincode);
                            }}
                            selectedValues={pinCodesData?.filter(
                              (el) => parseInt(el.pincode) === parseInt(uploadFormObj?.pin_code)
                            )}
                            displayValue={"pincode"}
                            disable={isUpdateMode ? true : false}
                            selectionLimit={1}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            {"Area"}
                            <span className="redStreSpan">{"*"}</span>
                          </Form.Label>
                          <CustomSelectDropdown
                            style={{
                              multiselectContainer: {
                                backgroundColor: "#f8f8f8",
                              },
                              chips: {
                                background: "#fbb040",
                                margin: 0,
                              },
                              option: {
                                background: "#fbb040",
                                color: "#FFFFFF",
                                borderBottom: "1px solid #FFFFFF",
                              },
                            }}
                            options={areaData}
                            onSelect={(e) => {
                              onSelectValue("area", e[0].area);
                            }}
                            selectedValues={areaData?.filter(
                              (el) => el.area === uploadFormObj?.area
                            )}
                            displayValue={"area"}
                            selectionLimit={1}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                );
              } else {
                return (
                  <Col xs={12} md={12}>
                    <Row>
                      <Col xs={12} md={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            {"Pin code"}
                            <span className="redStreSpan">{"*"}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={uploadFormObj?.pin_code || ""}
                            disabled={isUpdateMode ? true : false}
                            onChange={(e) =>
                              onSelectValueValidation("pin_code", e.target.value, 6, true)
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            {"Area"}
                            <span className="redStreSpan">{"*"}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={uploadFormObj?.area || ""}
                            onChange={(e) => onSelectValue("area", e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                );
              }
            })()}

            <Col xs={12} md={6} className="px-1" style={{ display: "flex", alignItems: "center" }}>
              <Form.Group className="mt-3" controlId="formBasicEmail">
                <Form.Check
                  type="checkbox"
                  name="radio_type"
                  checked={uploadFormObj?.set_default || false}
                  label={"Set default"}
                  className="square-checkbox mx-2"
                  onChange={(e) =>
                    onSelectValue(
                      "set_default",
                      Object.prototype.hasOwnProperty.call(uploadFormObj, "set_default")
                        ? !uploadFormObj.set_default
                        : true
                    )
                  }
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="action-buttons">
            {!addresses?.data?.length < 1 && (
              <CustomButton
                buttonClasses="close-btn"
                onClick={() => setIsCreateMode(false)}
                disabled={requestCall?.loading}
              >
                <i className="bi bi-x-lg"></i> {"Close"}
              </CustomButton>
            )}

            <CustomButton
              variant="primary"
              buttonClasses={!requestCall?.loading ? "submit-btn" : "submit-btn-loading"}
              type="submit"
              loading={requestCall?.loading}
            >
              <i className="bi bi-floppy"></i> {!isUpdateMode ? "create" : "update"}
            </CustomButton>
          </div>
        </Form>
      </Row>
    </>
  );

  return (
    <div className="p-0 company-info-container">
      {DialogModal}
      {(() => {
        if (!isCreateMode) {
          if (addresses?.data?.length > 0 && !addresses?.loading) {
            return (
              <Row className="address m-0">
                <Row className="heading-div ">
                  <Col xs={6} md={6} className="m-0 p-0">
                    <h5 className="text-uppercase">{"Address"}</h5>
                  </Col>
                  <Col xs={6} md={6} className="m-0 p-0 text-end">
                    <Button
                      className="btn-theme"
                      size="sm"
                      onClick={() => {
                        setIsCreateMode(true);
                        setIsUpdateMode(false);
                        setUploadFormObj({});
                        setErrorMsg({});
                        onSelectValue(
                          "country",
                          FilterObjectsByKeyValue(countries?.data, "name", "India")[0].name
                        );
                        onSelectValue(
                          "state",
                          FilterObjectsByKeyValue(countryStates?.data, "name", "Maharashtra")[0]
                            .name
                        );
                        if (userObj) {
                          if (userObj?.mobile_number) {
                            onSelectValue("primary_number", userObj?.mobile_number);
                          }
                          if (userObj?.business_info?.business_name) {
                            onSelectValue("full_name", userObj?.business_info?.business_name);
                          }
                        }
                      }}
                    >
                      <i className="bi bi-plus-lg"></i> Add
                    </Button>
                  </Col>
                </Row>
                <hr />
                {addresses?.data.map((address) => {
                  return (
                    <Row className="m-0 p-0 mt-3">
                      <Col xs={10} className="form-col left">
                        <h6 className="text-uppercase">{address.address_type_id.type_name}</h6>
                        <p>
                          <span>{"Full Name:"}</span>
                          <span className="mx-2 bold-span"> {address.full_name}</span>
                        </p>
                        <p>
                          {address.address_line_1} {address.address_line_2} {address.address_line_3}
                        </p>
                        <p>
                          <span>{"Primary number:"}</span>
                          <span className="mx-2 bold-span">{address.primary_number}</span>
                          {!isEmpty(address.alternate_number) ? (
                            <>
                              {"|| "}
                              <span>{"Alternate number: "}</span>
                              <span className="mx-2 bold-span">{address.alternate_number}</span>
                            </>
                          ) : null}
                        </p>

                        <p>
                          <span>{"City:"}</span>
                          <span className="mx-2 bold-span"> {address.city}</span>
                          <span>{"Pin Code:"}</span>
                          <span className="mx-2 bold-span">{address.pin_code}</span>
                          <span>{"Area:"}</span>
                          <span className="mx-2 bold-span">{address.area}</span>
                        </p>
                        <p>
                          <span>{"State:"}</span>
                          <span className="mx-2 bold-span">{address.state}</span>
                          <span>{"Country:"}</span>
                          <span className="mx-2 bold-span">{address.country}</span>
                        </p>
                      </Col>
                      <Col xs={2} className="form-col right">
                        <div className="action-button-box">
                          {/* {brandModal("icon-action-btn", <EditIcon />, row.original)} */}
                          <CustomButton
                            buttonClasses="icon-action-btn"
                            onClick={() => {
                              onSetUpdateObj(address);
                            }}
                          >
                            <EditIcon />
                          </CustomButton>
                          <CustomButton
                            buttonClasses="icon-action-btn"
                            onClick={async () => {
                              const isConfirmed = await confirm(
                                "Are you sure you want to delete?",
                                ""
                              );
                              if (isConfirmed) {
                                setLoading(true);
                                deleteUserAddressInfo(userId, address.id, dispatch)
                                  .then((res) => {
                                    if (res.success) {
                                      toast.success(res.message);
                                      callUserAddressInfoAPI(userId, dispatch);
                                    } else {
                                      toast.error(res.message);
                                    }
                                  })
                                  .finally(() => {
                                    setLoading(false);
                                  });
                              }
                            }}
                          >
                            <DeleteIcon />
                          </CustomButton>
                        </div>
                      </Col>
                    </Row>
                  );
                })}
              </Row>
            );
          } else if (addresses?.data?.length < 1 && !addresses?.loading) {
            return addressForm;
          } else if (addresses?.loading) {
            return <PageSpinner />;
          }
        } else if (isCreateMode) {
          return addressForm;
        }
      })()}
    </div>
  );
};

export default UserAddressInfo;
